import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import {axios,axiosz,axiosc,axioscBody,axioszBody,axioszBodys} from './axios/index';
import ElementUI from 'element-ui';//三方ui组件
import './element-variables.scss'
// import './theme/index.css';//自定义element-ui组件主题 如不需要则引入原始主题css 详情文档
import './assets/reset.css';//导入初始化样式
import './assets/common.scss';//导入公共样式
import Vuerify from 'vuerify';//表单验证
import BaiduMap from 'vue-baidu-map';//百度地图
import './assets/font/iconfont.css'; //导入矢量图标
import qs from 'qs';
// console.log = function () {};
// 编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
//地图 GYITHUGEzlm5UAajtqbakGqqmHwGVdrK
Vue.use(BaiduMap, {
  ak: 'fEXLlsdVivu8xZ5AS6xWxhWdGDicjQhU'
})

import '@/utils/extends'
import reg from './mixins/regular.js'
Vue.prototype.$reg = reg

//表单验证
Vue.use(Vuerify,{
  phone: {
    test: /^1[0-9]{10}$/,
    message: '手机号错误'
  },
  password:{
    test: /^[\w_-]{4,20}$/,
    message: '密码格式错误'
  },
  email:{
    test:/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
    message:'邮箱错误'
  },
  smsCode:{
    test: /^[1-9]{1}[0-9]{5}$/,
    message: '短信验证码错误'
  },
  code:{
    test:function(val){
        if(val && val.trim() !== ''){
            return true;
        }else{
            return false;
        }
    },
    message:"输入图形验证码"
  },
  userName:{
    test:/^[\w]{4,20}$/,
    message:'账号错误'
  },
  realName:{
    test:/^[\u4e00-\u9fa5]{0,}$/,
    message:'姓名错误'
  },
  manageName:{
    test:/\S/,
    message:'机构名称不能为空'
  }
});

Vue.config.productionTip = false;
Vue.prototype.$axios = axios; //挂载axios
Vue.prototype.$axiosz = axiosz; //挂载axiosz
Vue.prototype.$axiosc = axiosc; //挂载axiosc
Vue.prototype.$axioscBody = axioscBody; //挂载axiosc
Vue.prototype.$axioszBody = axioszBody; //挂载axiosc
Vue.prototype.$axioszBodys = axioszBodys; //挂载axiosc
Vue.prototype.$qs=qs;//挂载qs
Vue.use(ElementUI); //ui组件

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// 登录拦截
// 初始化进来和刷新做处理
if(!store.state.user.token){
  router.push('/login')
}
//路由跳转处理
router.beforeEach((to, from, next) => {
  if(to.path!='/login'){
    if(store.state.user.token){
      next();
    }else{
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    }
  }else{
    next();
  }
})
